const sections = {
  Carrier: {
    value: 'CARRIER',
    label: 'car.details.carrier'
  },
  Car: {
    value: 'CAR',
    label: 'car.details.car'
  },
  Driver: {
    value: 'DRIVER',
    label: 'car.details.driver.title'
  },
  Files: {
    value: 'FILES',
    label: 'car.details.files'
  }
}
export default sections
